import { RootState } from '@glass/web/modules/redux/types';
import selectUserConfig from '@glass/web/modules/userConfig/selectors/selectUserConfig';

const selectGeoAccuracyRadius = (state: RootState) =>
  selectUserConfig(state)?.geo?.location?.accuracyRadius;

export default selectGeoAccuracyRadius;
